import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=0dea9f74&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=0dea9f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea9f74",
  null
  
)

export default component.exports